import { baseUrl } from "../../../../boot";
import axios from "axios";

// Add client
export const addSalesOrders = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}sales/orders/api/v1/createSalesOrder`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const addOrder = addSalesOrders;

export const getSalesOrderById = async (orderid) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(
      `${baseUrl}sales/orders/api/v1/getSalesOrderById/${orderid}`,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    // console.log("getSalesOrderById response - ", response)
    return response;
  } catch (error) {
    throw error;
  }
};

// delete client  API
export const deleteSalesOrder = async (ROWID) => {
  console.log({ ROWID });
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(
      `${baseUrl}sales/orders/api/v1/deleteSalesOrderById/${ROWID}`,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    console.log("Error is - ", error);
    throw error;
  }
};

// update clients
export const updateSalesOrder = async (ROWID, data) => {
  console.log({ data });
  // const ROWID = data.ROWID
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(
      `${baseUrl}sales/orders/api/v1/updateSalesOrderById/${ROWID}`,
      data,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    console.log("updateSalesOrder response - ", response);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateOrders = updateSalesOrder;

// total count
export const countClient = async (formData) => {
  console.log(formData, "count");
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(
      `${baseUrl}crm/api/v1/get-contact-count`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const countOrders = countClient;

export const getClientDetailById = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(
      `${baseUrl}crm/api/v1/get-contact-by-id/${id}`,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response;
  } catch (error) {
    throw error;
  }
};

// Add client
export const getClientRelatedTasks = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-task-by-contactID`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Add client
export const getClientRelatedNotes = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-note-by-contactID`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Add client
export const getClientRelatedDeal = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}crm/api/v1/get-deal-by-contactID`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShippingCharges = async (formData) => {
  console.log("client form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}shippingCharges/api/v1/create`,
      formData,
      {
        headers: {
          "auth-token": token,
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//Zoho Books API

export const addSalesOrderinZohoBooks = async (Id) => {
  console.log("zoho books sales order form id ---- ", Id);
  // const token = localStorage.getItem("authToken")
  try {
    const response = await axios.post(
      `${baseUrl}zohoBooks/api/v1/salesorders/${Id}`,
      {
        // headers: {
        //   "auth-token": token,
        // }
      },
    );
    console.log("zoho boooks response", response);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateSalesOrderinZohoBooks = async (Id, data) => {
  console.log("zoho books sales order form id ---- ", Id);
  // const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(
      `${baseUrl}zohoBooks/api/v1/salesorders/${Id}`,
      data,
      {
        // headers: {
        //   "auth-token": token,
        // }
      },
    );
    console.log("zoho boooks response", response);
    return response;
  } catch (error) {
    throw error;
  }
};
